<template>
  <v-card class="relative">
    <v-card-text>
      <v-row>
          <v-col v-for="(field,index) in fields" :key="`fields-${index}-${field.title}`" cols="12">
            <component
              :is="field.component"
              v-model="doc[field.model]"
              :title="field.title"
              :label="field.title"
              :prefix="field.prefix"
              :color="field.color"
              class=""
            />
          </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// const fb = require("@/firebaseConfig.js");

import { UnitTextArea, UnitTextField, UnitTag, UnitHidden, UnitFlag } from "@/components/units";

export default {
  name: "UserServiceForm",
  data() {
    return {
      doc: this.value,
      fields: [
        {
          title: "Title",
          count: 1,
          component: UnitHidden,
          model: "title",
          color: "amber"
        },
        {
          title: "Flag",
          count: 1,
          component: UnitFlag,
          model: "flag",
          color: "amber"
        },
        {
          title: "Strapline",
          count: 1,
          component: UnitTextArea,
          model: "concept",
          color: "amber"
        },
        {
          title: "Description",
          count: 2,
          component: UnitTextArea,
          model: "description",
          color: "amber"
        },
        {
          title: "Promise",
          count: 3,
          component: UnitTextArea,
          model: "promise",
          color: "amber"
        },
        {
          title: "Justification",
          count: 4,
          component: UnitTag,
          model: "justification",
          color: 'cyan darken-2'
        },
        {
          title: "Pillars",
          count: 5,
          component: UnitTag,
          model: "pillars",
          color: 'cyan darken-2'
        },
      ]
    };
  },
  components: {
    UnitTextArea,
    UnitTextField,
    UnitTag,
    UnitFlag,
    UnitHidden
  },
  props: {
    value: Object
  },
  watch: {
    doc: {
      deep: true,
      handler(val) {
        this.$emit("input", val);
      },
    },
    value(val) {
      this.doc = val;
    },
  },
};
</script>
